/* es5-ext/function/is-function */ function _(require, module, exports) {
    var objToString = Object.prototype.toString, id = objToString.call(require(307) /* ./noop */);
    module.exports = function (value) {
        return typeof value === "function" && objToString.call(value) === id;
    };
}
